import { Dimensions, Platform } from 'react-native';
import { GluestackStyleSheet } from './style-sheet';
import { extractWidthValues } from './utils';
export function getClosestBreakpoint(values, point) {
  const dimValues = Object.values(values);
  let index = -1;
  let breakpointsObj = {};
  for (let i = 0; i < dimValues.length; i++) {
    breakpointsObj[dimValues[i]] = i;
  }
  const breakpoints = Object.keys(breakpointsObj);
  for (let i = 0; i < breakpoints.length; i++) {
    if (parseInt(breakpoints[i]) === point) {
      index = breakpointsObj[breakpoints[i]];
      break;
    } else if (parseInt(breakpoints[i]) > point && i !== 0) {
      index = breakpointsObj[breakpoints[i - 1]];
      break;
    }
    // If windowWidth is greater than last available breakpoint clamp it to last index
    else if (parseInt(breakpoints[i]) < point && i === dimValues.length - 1) {
      index = breakpointsObj[breakpoints[i]];
      break;
    }
  }
  return breakpoints[index];
}
function getMinWidthFromMediaQuery(mediaQuery) {
  const regex = /\(\s*min-width:\s*(\d+)px\s*\)/;
  const matches = regex.exec(mediaQuery);
  if (matches) {
    return parseInt(matches[1], 10);
  }
  return 0;
}
export function getClosestBreakpointValue(mediaQueries, value) {
  if (!mediaQueries) return;
  const dimValues = Object.values(mediaQueries);
  let index = -1;
  let breakpointsObj = {};
  for (let i = 0; i < dimValues.length; i++) {
    const minWidth = getMinWidthFromMediaQuery(dimValues[i]);
    breakpointsObj[minWidth] = dimValues[i];
  }
  const breakpoints = Object.keys(breakpointsObj);
  for (let i = 0; i < breakpoints.length; i++) {
    if (parseInt(breakpoints[i]) === value) {
      index = breakpoints[i];
      break;
    } else if (parseInt(breakpoints[i]) > value && i !== 0) {
      index = breakpoints[i - 1];
      break;
    }
    // If windowWidth is greater than last available breakpoint clamp it to last index
    else if (parseInt(breakpoints[i]) < value && i === dimValues.length - 1) {
      index = breakpoints[i];
      break;
    }
  }
  return index;
}
export function isValidBreakpoint(config, queryCondition, width = (_Dimensions$get => (_Dimensions$get = Dimensions.get('window')) === null || _Dimensions$get === void 0 ? void 0 : _Dimensions$get.width)()) {
  const windowWidth = width;
  const currentBreakpointValue = getClosestBreakpointValue(config.tokens.mediaQueries, windowWidth);
  const queryWidth = extractWidthValues(queryCondition);
  if (queryWidth.length > 0) {
    if (queryWidth.length === 1) {
      if (queryWidth[0] !== null && queryWidth[0] <= currentBreakpointValue) {
        return true;
      }
    } else {
      if (currentBreakpointValue >= queryWidth[0] && currentBreakpointValue <= queryWidth[1]) {
        return true;
      }
    }
  }
  return false;
}
function getDataStyle(props, styleCSSIdsString) {
  if (Platform.OS === 'web') {
    var _props$dataSet, _props$dataSet2;
    if (props !== null && props !== void 0 && (_props$dataSet = props.dataSet) !== null && _props$dataSet !== void 0 && _props$dataSet.style && props !== null && props !== void 0 && props['data-style']) {
      return props['data-style'] + ' ' + props.dataSet.style + ' ' + styleCSSIdsString;
    } else if (props !== null && props !== void 0 && (_props$dataSet2 = props.dataSet) !== null && _props$dataSet2 !== void 0 && _props$dataSet2.style) {
      return props.dataSet.style + ' ' + styleCSSIdsString;
    } else if (props !== null && props !== void 0 && props['data-style']) {
      return props['data-style'] + ' ' + styleCSSIdsString;
    } else {
      return styleCSSIdsString;
    }
  } else {
    return '';
  }
}
export function generateStylePropsFromCSSIds(props, styleCSSIds, config, activeThemes, componentConfig) {
  function containsAllItems(arr1, arr2) {
    // Check if every item in arr2 is included in arr1
    return arr2.every(item => arr1.includes(item));
  }
  const propsStyles = Array.isArray(props === null || props === void 0 ? void 0 : props.style) ? props === null || props === void 0 ? void 0 : props.style : [props === null || props === void 0 ? void 0 : props.style];

  // for RN
  const styleObj = [];
  let styleCSSIdsString = '';
  if (styleCSSIds.length > 0) {
    if (Platform.OS !== 'web') {
      const nativeStyleMap = GluestackStyleSheet.getStyleMap();
      styleCSSIds.forEach(cssId => {
        const nativeStyle = nativeStyleMap.get(cssId);
        // console.log(nativeStyle, 'style map here 111');

        if (nativeStyle) {
          var _nativeStyle$meta, _nativeStyle$meta2;
          const queryCondition = nativeStyle === null || nativeStyle === void 0 || (_nativeStyle$meta = nativeStyle.meta) === null || _nativeStyle$meta === void 0 ? void 0 : _nativeStyle$meta.queryCondition;
          const themeCondition = (nativeStyle === null || nativeStyle === void 0 || (_nativeStyle$meta2 = nativeStyle.meta) === null || _nativeStyle$meta2 === void 0 || (_nativeStyle$meta2 = _nativeStyle$meta2.theme) === null || _nativeStyle$meta2 === void 0 ? void 0 : _nativeStyle$meta2.split('.')) ?? [];
          const styleSheet = nativeStyle === null || nativeStyle === void 0 ? void 0 : nativeStyle.resolved;
          if (queryCondition && themeCondition) {
            if (isValidBreakpoint(config, queryCondition)) {
              if (containsAllItems(activeThemes, themeCondition)) {
                styleObj.push(styleSheet);
              }
            }
          } else if (queryCondition) {
            if (isValidBreakpoint(config, queryCondition)) {
              styleObj.push(styleSheet);
            }
          } else if (themeCondition && activeThemes) {
            if (containsAllItems(activeThemes, themeCondition)) {
              styleObj.push(styleSheet);
            }
          } else {
            styleObj.push(styleSheet);
          }
          if (activeThemes) {
            activeThemes.forEach(activeTheme => {
              if (containsAllItems(activeThemes, themeCondition)) {
                var _nativeStyle$themeRes;
                styleObj.push(nativeStyle === null || nativeStyle === void 0 || (_nativeStyle$themeRes = nativeStyle.themeResolved) === null || _nativeStyle$themeRes === void 0 ? void 0 : _nativeStyle$themeRes[activeTheme]);
              }
            });
          }
        }
      });
    } else {
      styleCSSIdsString = styleCSSIds.join(' ');
    }
  }
  Object.assign(props, {
    'style': propsStyles ? [...styleObj, ...propsStyles] : styleObj,
    'dataSet': {
      ...(props === null || props === void 0 ? void 0 : props.dataSet),
      style: getDataStyle(props, styleCSSIdsString)
    },
    // DONOT REMOVE THIS LINE, THIS IS FOR SPECIFIC COMPONENTS LIKE next/link
    'data-style': getDataStyle(props, styleCSSIdsString)
  });
  if (Platform.OS === 'web') {
    Object.assign(props, {
      dataSet: {
        ...(props === null || props === void 0 ? void 0 : props.dataSet),
        componentConfig: JSON.stringify(componentConfig)
      }
    });
  }
  return props;
}
//# sourceMappingURL=generateStylePropsFromCSSIds.js.map